import { createReducer } from "@reduxjs/toolkit";

import {
  getCounters,
  getCountersSuccess,
  getCountersFailure,
  getDistributions,
  getDistributionsSuccess,
  getDistributionsFailure,
  getSales,
  getSalesSuccess,
  getSalesFailure,
  getIncome,
  getIncomeSuccess,
  getIncomeFailure,
  getTransactions,
  getTransactionsSuccess,
  getTransactionsFailure,
} from "./actions";

const initialState = {
  totalCount: 0,
  usdIncome: 0,
  cryptoIncome: 0,
  recurrentPercentage: 0,
  isStatsLoading: false,
  isSalesLoading: false,
  isDistributionsLoading: false,
  isIncomeLoading: false,
  isTransactionsLoading: false,
  income: [], // { label, value }[]
  transactions: [], // { label, usdCount, cryptoCount }[]
  sales: [], // { label, subscriptionsValue, separateContentValue, donationsValue, promotionsValue }[]
  usdPercentage: undefined,
  cryptoPercentage: undefined,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getCounters.type, (state) => ({
      ...state,
      isStatsLoading: true,
    }))
    .addCase(getCountersSuccess.type, (state, { payload }) => ({
      ...state,
      ...payload,
      isStatsLoading: false,
    }))
    .addCase(getCountersFailure.type, (state) => ({
      ...state,
      isStatsLoading: false,
    }))
    .addCase(getDistributions.type, (state) => ({
      ...state,
      isDistributionsLoading: true,
    }))
    .addCase(getDistributionsSuccess.type, (state, { payload }) => ({
      ...state,
      ...payload,
      isDistributionsLoading: false,
    }))
    .addCase(getDistributionsFailure.type, (state) => ({
      ...state,
      isDistributionsLoading: false,
    }))
    .addCase(getSales.type, (state) => ({
      ...state,
      isSalesLoading: true,
    }))
    .addCase(getSalesSuccess.type, (state, { payload }) => ({
      ...state,
      sales: payload,
      isSalesLoading: false,
    }))
    .addCase(getSalesFailure.type, (state) => ({
      ...state,
      isSalesLoading: false,
    }))
    .addCase(getIncome.type, (state) => ({
      ...state,
      isIncomeLoading: true,
    }))
    .addCase(getIncomeSuccess.type, (state, { payload }) => ({
      ...state,
      income: payload,
      isIncomeLoading: false,
    }))
    .addCase(getIncomeFailure.type, (state) => ({
      ...state,
      isIncomeLoading: false,
    }))
    .addCase(getTransactions.type, (state) => ({
      ...state,
      isTransactionsLoading: true,
    }))
    .addCase(getTransactionsSuccess.type, (state, { payload }) => ({
      ...state,
      transactions: payload,
      isTransactionsLoading: false,
    }))
    .addCase(getTransactionsFailure.type, (state) => ({
      ...state,
      isTransactionsLoading: false,
    }));
});
